import React from "react";

import GraficoDonut from "./GraficoDonut.jsx";

import Modal from "../lib_react_adminlte/componentes/Modal.jsx";
import { Column, Table } from "../lib_react_adminlte/componentes/Table.jsx";

import "./style/CountBox.css";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

class CountBox extends React.Component {
  mostarMais() {
    this.mostrarMais.show();
  }

  renderColumns = (info) => {
    const lista = [];

    lista.push(
      <Column style={{ width: "10%" }} key={1} field="ranking" header="" />
    );

    lista.push(
      <Column
        style={{ width: isMobile ? "42%" : "55%" }}
        key={2}
        field="descricao_1"
        header="Nome"
      />
    );
    lista.push(
      <Column
        style={{ width: isMobile ? "16%" : "20", textAlign: "right" }}
        key={3}
        field="valor_1"
        header="Valor"
      />
    );
    lista.push(
      <Column
        style={{ width: "15%", textAlign: "right" }}
        key={4}
        field="margem_lucro"
        header="Margem"
      />
    );

    return lista;
  };


  renderLinha(text, value) {
    return (
      <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div className="itens-text-normal-box-bold">
        <spam>{text} </spam>
        <br />
      </div>

      <div
        style={{
          textAlign: "end",
          width: "35%",
        }}
      >
        <spam
          style={{
            fontSize: "12px",
          }}
        >
          {value}
        </spam>

        <br />
      </div>
    </div>
    )
  }

  renderItem(info) {
    return (
      <div
        className={
          isMobile &&
            !info.usaBarraHorizontal &&
            !info.usaBarraVertical &&
            !info.normal
            ? "info-box-com-grafico"
            : info.usaBarraHorizontal && isMobile
              ? "info-box-com-tickes"
              : info.normal && isMobile
                ? "info-box-normal"
                : "info-box"
        }
      >
        <div className="icon-content" style={{ width: "25%" }}>
          <span
            className={"info-box-icon " + info.bgColor}
            style={isMobile ? {} : { width: "100%", textAlign: "center" }}
          >
            {!isMobile ? (
              <i
                style={{ fontSize: "80px", paddingTop: "15px" }}
                className={"fa " + info.icon}
              />
            ) : (
              <i
                style={
                  info.grafic ? { paddingTop: "110%" } : { paddingTop: "30%" }
                }
                className={"fa " + info.icon}
              />
            )}
          </span>
        </div>
        <div
          className="info-box-content "
          style={{ ...info.syles, width: "70%" }}
        >
          <Modal
            // style={{ height: "550px", width: "500px" }}
            title={info.title}
            ref={(e) => (this.mostrarMais = e)}
          >
            <div className="row">
              <div className="col-sm-12">
                <Table
                  hideActions={true}
                  className="tabelaMed"
                  style={{ width: "100%" }}
                  maxHeight={"calc(100vh - 400px)"}
                  selectable
                  orderOnClick
                  data={info.dados_tabela || []}
                >
                  {this.renderColumns(this.props.dados)}
                </Table>
              </div>
            </div>
          </Modal>
          {info.usaBarraHorizontal && (
            <div
              className={
                isMobile
                  ? "padding-content-span-mobile"
                  : "padding-content-span"
              }
            >
              <div
                style={{
                  paddingBottom: "4px",
                  height: "5px",
                  textAlign: "center",
                }}
              >
                <span style={{ fontWeight: "bold" }}>{info.title}</span>
              </div>
              <br />
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div className="itens-barra-horizontal-texto-left">
                    <span>{info.smallText}</span> <br />
                  </div>

                  <div className="itens-barra-horizontal-texto-right">
                    <span>{info.value1}</span> <br />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div className="itens-barra-horizontal-texto-left">
                    {info.smallText2 && <span>{'C-' + info.smallText2}</span>}
                    {info.smallText2 && <br />}
                  </div>

                  <div className="itens-barra-horizontal-texto-right">
                    <span>{info.value2}</span> <br />
                  </div>
                </div>
              </div>
              <br />
              <div className="info-box-hr-horizontal"></div>
              <div
                style={{
                  marginTop: "14px",
                  marginBottom: "4px",
                  textAlign: "center",
                }}
              >
                <span style={{ fontWeight: "bold" }}>{info.title2}</span>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div className="itens-barra-horizontal-texto-left">
                    <span>{info.smallText3}</span> <br />
                  </div>

                  <div className="itens-barra-horizontal-texto-right">
                    <span>{info.value3}</span> <br />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div className="itens-barra-horizontal-texto-left">
                    {info.smallText4 && <span>{info.smallText4}</span>}
                    {info.smallText4 && <br />}
                  </div>

                  <div className="itens-barra-horizontal-texto-right">
                    <span>{info.value4}</span> <br />
                  </div>
                </div>
              </div>
            </div>
          )}

          {info.normal && (
            <div>
              <span>{info.title}</span>
              <span style={{ fontSize: "17px" }}>{info.bigText}</span>
              {info.dados_tabela && (
                <div>
                  <div className="itens-content-normal-box">
                    {info.dados_tabela.map(function (dado, index) {
                      if (index <= 2) {
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div className="itens-text-normal-box-bold">
                              <spam>{dado.descricao_1} </spam>
                              <br />
                            </div>

                            <div
                              style={{
                                textAlign: "end",
                                width: "35%",
                              }}
                            >
                              <spam
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {dado.valor_1}
                              </spam>
                              <spam
                                style={{
                                  fontSize: "10px",
                                }}
                              >
                                {" (Rt: " + dado.margem_lucro + "%)"}
                              </spam>
                              <br />
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  {info.lookmore &&
                    info.dados_tabela &&
                    info.dados_tabela.length > 0 && (
                      <div
                        onClick={this.mostarMais.bind(this)}
                        style={{ paddingTop: "10px" }}
                      >
                        <span className="info-box-lookmore">
                          {info.lookmore}
                        </span>
                      </div>
                    )}
                </div>
              )}
            </div>
          )}

          {info.usaBarraHorizontal ||
            info.usaBarraVertical ||
            info.normal ? null : (
            this.props.personalizado ? (
              // essa parte aqui foi criada na correria apenas para corrigir o problema do cliente
              // deverá ser melhorado essa rotina futuramente, o problema é a repetição de código. 
              <div>
                {this.renderLinha(info.smallText1, info.value1)}
                {this.renderLinha(info.smallText2, info.value2)}
                {this.renderLinha(info.smallText3, info.value3)}
               
              </div>
            ) : (
              <div>
                <span className="item-title-graphic">{info.title}</span>
                {info.title && <br />}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div className="left-sides">
                    <span>{info.smallText}</span>
                    {info.smallText && <br />}

                    {info.smallText2 && <span>{info.smallText2}</span>}
                    {info.smallText2 && <br />}

                    {info.title2 && <span>{info.title2}</span>}
                    {info.title2 && <br />}

                    {info.smallText3 && <span>{info.smallText3}</span>}
                    {info.smallText3 && <br />}

                    {info.smallText4 && <span>{info.smallText4}</span>}
                    {info.smallText4 && <br />}
                  </div>

                  <div className="right-sides">
                    <span className="rodaContador">{info.value1}</span>
                    {info.value1 && <br />}
                    <span className="rodaContador">{info.value2}</span>
                    {info.value2 && <br />}
                    <span className="rodaContador">{info.value3}</span>
                    {info.value3 && <br />}
                  </div>

                  <div className="graphic-web">
                    {info.grafic && (
                      <div
                        className="BlocoDuploHeight"
                        style={{
                          width: "150px",
                          marginTop: "-20px",
                          marginLeft: "50px",
                        }}
                      >
                        <div className="Grafico" style={{ position: "relative" }}>
                          <GraficoDonut
                            labels={["Meta Atindiga", ""]}
                            data={[
                              {
                                label: "nomeDaLinha",
                                type: "doughnut",
                                fill: false,
                                data: [info.valorGrafico1, info.valorGrafico2],
                                grafic: true,
                                backgroundColor: ["#0099e0", "#adb2b5"],
                                // pointBorderColor: "rgb(255, 255, 255)",
                                pointStyle: "line",
                                borderWidth: 3,
                              },
                            ]}
                          />
                        </div>
                        {
                          <div className="grafic-porcentage">
                            {info.valorGrafico1 + "%"}
                          </div>
                        }
                      </div>
                    )}
                  </div>
                </div>
              </div>)
          )}

          {info.usaBarraHorizontal || info.usaBarraVertical ? null : (
            <div className={"graphic-mobile"}>
              {info.grafic && (
                <div
                  className="BlocoDuploHeight"
                  style={{
                    width: "150px",
                    marginTop: "-20px",
                    marginLeft: "50px",
                  }}
                >
                  <div className="Grafico" style={{ position: "relative" }}>
                    <GraficoDonut
                      labels={["Meta Atindiga", ""]}
                      data={[
                        {
                          label: "nomeDaLinha",
                          type: "doughnut",
                          fill: false,
                          data: [info.valorGrafico1, info.valorGrafico2],
                          grafic: true,
                          backgroundColor: ["#0099e0", "#adb2b5"],
                          pointBorderColor: "rgb(255, 255, 255)",
                          pointStyle: "line",
                          borderWidth: 3,
                        },
                      ]}
                    />
                    <div className="grafic-porcentage-mobile">
                      {info.valorGrafico1 + "%"}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {info.usaBarraVertical && (
            <div style={{ justifySelf: "center", marginTop: "2%" }}>
              {/* 1o Titulo do Cabecalho */}

              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: "bold",
                }}
              >
                {info.titleV1}
              </span>

              <div style={{ display: "flex", flexDirection: "row" }}>
                {/* 1o Bloco do Lado Esquerdo */}
                <div
                  style={{ width: "50%" }}
                  className={
                    isMobile
                      ? "padding-content-span-left-mobile"
                      : "padding-content-span-left"
                  }
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {info.title}
                  </span>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                    className="rodaContador"
                  >
                    {info.smallText} <br />
                  </span>

                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {'B-' + info.smallText2}
                  </span>
                </div>

                {/* 1o Bloco do Lado Direito */}
                <div
                  style={{ width: "50%" }}
                  className="padding-content-span-right"
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {info.smallText6}
                  </span>
                  <span
                    style={{ display: "flex", justifyContent: "center" }}
                    className="rodaContador"
                  >
                    {info.smallText7} <br />
                  </span>

                  <span style={{ display: "flex", justifyContent: "center" }}>
                    {info.smallText8}
                  </span>
                </div>
              </div>

              {/* 2o Titulo do Cabecalho */}
              <apan
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "4px",
                  fontWeight: "bold",
                }}
              >
                {info.titleV2}
              </apan>

              <div style={{ display: "flex", flexDirection: "row" }}>
                {/* 2o Bloco do Lado Esquerdo */}
                <div
                  style={{ width: "50%" }}
                  className={
                    isMobile
                      ? "padding-content-span-left-mobile"
                      : "padding-content-span-left"
                  }
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {info.smallText4}
                  </span>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {info.smallText5}
                  </span>
                </div>

                {/* 2o Bloco do Lado Direito */}
                <div
                  className="padding-content-span-right"
                  style={{ width: "50%" }}
                >
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    {info.smallText10}
                  </span>
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    {info.smallText11}
                  </span>
                </div>
              </div>
            </div>
          )}
          {info.mesAnterior}
          {info.semanaAnterior}
          {info.anoAnterior}
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.renderItem(this.props.dados)}</div>;
  }
}
export default CountBox;



// WEBPACK FOOTER //
// ./src/componentes/CountBox.jsx